import React from 'react';
import classnames from 'classnames';

import SvgFormat from 'common/helpers/svgFormat';

export default function RadioCard({ methodName, icon, isChecked = false, children }) {
  return (
    <div className="radio-card-wrapper">
      <div className={classnames('radio-card', isChecked && 'active')}>
        <div className="card-left">
          <SvgFormat className="icon" type={icon} />
          <div className={classnames('card-name', !isChecked && 'normal-font')}>{methodName}</div>
        </div>
        <div className={isChecked ? 'checked' : 'check-icon'} />
      </div>
      {isChecked && <div>{children}</div>}
    </div>
  );
}
